import { createReducer } from '@reduxjs/toolkit'

import { BonusPromotionStatus } from 'shared/models/Promotion'

import * as actions from '../actions'
import { IBonusSystemState } from '../types'

const initialState: IBonusSystemState['data'] = {
  promotionsPolling: {
    count: 0,
    page: 1,
    promos: [],
  },
  activePromotions: {
    count: 0,
    page: 1,
    promos: [],
  },
  promotions: {
    count: 0,
    page: 1,
    promos: [],
  },
  tab: BonusPromotionStatus.active,
}
export default createReducer(initialState, builder => {
  builder
    .addCase(actions.getUserPromotions.reset, (state, action) => {
      state.promotions = initialState.promotions
    })
    .addCase(actions.getUserPromotions.success, (state, action) => {
      state.promotions = action.payload
    })
    .addCase(actions.getMoneyFromPromotion.success, (state, action) => {
      state.promotions.promos = state.promotions.promos.map(card =>
        String(card.id) === action.payload.id ? action.payload.data : card,
      )
      state.promotionsPolling.promos = state.promotionsPolling.promos.map(card =>
        String(card.id) === action.payload.id ? action.payload.data : card,
      )
    })
    .addCase(actions.getUserPromotionsPoll.reset, (state, action) => {
      state.promotionsPolling = initialState.promotions
    })
    .addCase(actions.getUserPromotionsPoll.success, (state, action) => {
      state.promotionsPolling = action.payload
    })
    .addCase(actions.getUserActivePromotions.reset, (state, action) => {
      state.activePromotions = initialState.activePromotions
    })
    .addCase(actions.getUserActivePromotions.success, (state, action) => {
      state.activePromotions = action.payload
    })
    .addCase(actions.setTab, (state, action) => {
      state.tab = action.payload
    })
})
